/** Részletes statisztika — autónként fix szín a grafikonon és a fiók kártyákon. */

export const STATS_CAR_PALETTE = [
  "#2563EB",
  "#8B5CF6",
  "#F59E0B",
  "#EC4899",
  "#14B8A6",
  "#F97316",
  "#6366F1",
  "#22C55E",
];

export function statsEnabledCars(cars = []) {
  return (cars || []).filter((c) => c.detailed_stats);
}

export function statsColorForCar(carId, statsCarIds) {
  const ids = statsCarIds || [];
  const idx = ids.indexOf(carId);
  if (idx < 0) return STATS_CAR_PALETTE[0];
  return STATS_CAR_PALETTE[idx % STATS_CAR_PALETTE.length];
}

export function statsCarShortLabel(car) {
  if (!car) return "";
  const t = `${car.make || ""} ${car.model || ""}`.trim();
  return t || "Autó";
}
